export const USERNAME = "maze-runner-username";
export const USERID = "maze-runner-userid";
